import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Datetime from "react-datetime";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import moment from "moment";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import { CommonConfig } from "CommonConfig";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import GridContainer from "components/Grid/GridContainer";
import { MultiSelect } from "primereact/multiselect";
import _ from "lodash";

const AddManufacturing = (props) => {
  const [userId, setUserId] = useState("");
  const [manufacturingId, setManufacturingId] = useState("");
  const [multiplyProcessDialog, setMultiplyProcessDialog] = useState(false);
  const [tempProcessMultiplyList, setTempProcessMultiplyList] = useState([]);
  const [processMultiplyList, setProcessMultiplyList] = useState([]);
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [addBatchDialog, setAddBatchDialog] = useState(false);
  const [addDataDialog, setAddDataDialog] = useState(false);
  const [batchDetails, setBatchDetails] = useState({});
  const [addDataDetails, setAddDataDetails] = useState({
    item: "",
    itemErr: false,
    itemErrText: "",
    unit: "",
    unitErr: false,
    unitErrText: "",
    quantity: "",
    quantityErr: false,
    quantityErrText: "",
    rate: "",
    rateErr: "",
    rateErrText: "",
    mrp: "",
  });
  const [editInputDataList, setEditInputDataList] = useState([]);
  const [formData, setFormData] = useState({
    manufacturingDate: new Date(),
    manufacturingDateErr: false,
    manufacturingDateErrText: "",
    process: [],
    processErr: false,
    processErrText: "",
    warehouse: "",
    salesOrder: "",
    salesOrderNo: "",
    warehouseErr: false,
    warehouseErrText: "",
    isBatch: false,
  });

  const [itemList, setItemList] = useState([]);
  const [inputList, setInputList] = useState([]);
  const [outputList, setOutputList] = useState([]);
  const [batchesList, setBatchesList] = useState({});
  const [dropdownData, setDropdownData] = useState({
    process: [],
    warehouse: [],
    product: [],
    salesOrder: [],
    hsnCode: [],
    brands: [],
    units: [],
  });

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);

    if (props.location?.state && props.location.state.ManufacturingId) {
      GetManufacturingById(data);
      if (props.location.state.Type === "View") {
        setReadOnly(true);
      } else {
        GetProductMaster(data);
        GetProcessMaster(data);
        GetWarehouseMaster(data);
        GetUnitMaster(data);
        GetBrandMaster(data);
        GetHSNCodeMaster(data);
        GetSalesOrderList(data);
        GetGSTMaster(data);
      }
    } else {
      GetProductMaster(data);
      GetProcessMaster(data);
      GetWarehouseMaster(data);
      GetUnitMaster(data);
      GetBrandMaster(data);
      GetHSNCodeMaster(data);
      GetSalesOrderList(data);
      GetGSTMaster(data);
    }
  }, []);

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            product: filterArry,
          }));

          let itemBatchList = {};
          filterArry.forEach((product) => {
            itemBatchList[product.value] = product.Variant?.Batches.map(
              (batch) => ({
                ...batch,
                label: batch.BatchNo,
                value: batch._id,
              })
            );
          });
          // console.log({ itemBatchList });
          setBatchesList(itemBatchList);
        }
      })
      .catch((err) => { });
  };

  const GetProcessMaster = async (UserId) => {
    try {
      let params = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetProcessMaster, params)
        .then((response) => {
          if (response.Success === 1) {
            setDropdownData((prevState) => ({
              ...prevState,
              process: response.Data.map((item) => ({
                ...item,
                label: item.ProcessName,
                value: item._id,
              })),
            }));
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetWarehouseMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (item) => ({
              ...item,
              label: item.Name,
              value: item._id,
            })
          );
          setDropdownData((prevState) => ({
            ...prevState,
            warehouse: filterArry,
          }));
        }
      })
      .catch((err) => { });
  };

  const GetUnitMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            units: filterArry,
          }));
        }
      })
      .catch((err) => { });
  };

  const GetBrandMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setDropdownData((prevState) => ({
            ...prevState,
            brands: filterArry,
          }));
        }
      })
      .catch((err) => { });
  };

  const GetHSNCodeMaster = async (UserId) => {
    let params = {
      UserId: UserId,
    };
    api
      .post(APIConstant.path.GetHSNCodeMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          setDropdownData((prevState) => ({
            ...prevState,
            hsnCode: filterArry,
          }));
        }
      })
      .catch((err) => { });
  };

  const GetGSTMaster = async (UserId) => {
    let params = {
      UserId: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          setDropdownData((prevState) => ({
            ...prevState,
            gstRates: filterArry,
          }));
        }
      })
      .catch((err) => { });
  };

  const GetSalesOrderList = async (UserId) => {
    let params = {
      UserId,
      OrderStatus: "Pending",
    };
    api
      .post(APIConstant.path.GetSalesOrder, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          setDropdownData((prevState) => ({
            ...prevState,
            salesOrder: response.Data.map((so) => ({
              ...so,
              label: so.SalesOrderNo,
              value: so._id,
            })),
          }));
        }
      })
      .catch((err) => {});
  };
  const GetManufacturingById = async (UserId) => {
    try {
      let params = {
        UserId,
        ManufacturingId: props.location.state.ManufacturingId,
      };
      api
        .post(APIConstant.path.GetManufacturingById, params)
        .then((response) => {
          if (response.Success === 1) {
            const {
              ManufacturingDate,
              SalesOrderId,
              SalesOrderNo,
              InputItems,
              OutputItems,
              IsBatch,
              Process,
              ProcessDetails,
              Warehouse,
              WarehouseDetails,
              _id,
            } = response.Data;
            setFormData((prevState) => ({
              ...prevState,
              manufacturingDate: ManufacturingDate,
              process: Process,
              processDetails: ProcessDetails,
              salesOrder: SalesOrderId,
              salesOrderNo: SalesOrderNo,
              warehouse: Warehouse,
              warehouseDetails: WarehouseDetails,
              isBatch: IsBatch,
            }));

            setManufacturingId(_id);
            setInputList(InputItems);
            setOutputList(OutputItems);
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => { });
    } catch (e) {
      console.log(e);
    }
  };

  const AddUpdateManufacturing = async () => {
    setLoading(true);

    if (!validate()) return setLoading(false);

    try {
      const payload = {
        SalesOrderId: formData.salesOrder,
        SalesOrderNo: formData.salesOrder
          ? dropdownData.salesOrder.find(
              (so) => so.value === formData.salesOrder
            )?.label
          : "",
        ManufacturingDate: formData.manufacturingDate,
        Process: formData.process,
        ProcessDetails: formData.process.map((processId) => {
          return {
            id: processId,
            name: dropdownData.process.find((item) => item.value === processId)
              ?.label,
          };
        }),
        Warehouse: formData.warehouse,
        WarehouseDetails: formData.warehouse.map((warehouseId) => {
          return {
            id: warehouseId,
            name: dropdownData.warehouse.find(
              (item) => item.value === warehouseId
            )?.label,
          };
        }),
        IsBatch: !!formData.isBatch,

        InputList: inputList.map((item) => {
          return {
            _id: item._id,
            ProcessId: item.ProcessId,
            ItemId: item.ItemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.ItemId
            )?.label,
            Quantity: item.Quantity,
            OriginalQuantity: item.OriginalQuantity,
            UnitId: item.UnitId,
            UnitName: dropdownData.units.find(
              (obj) => obj.value === item.UnitId
            )?.label,
            OriginalUnitId: item.OriginalUnitId,
            Rate: item.Rate,
            Mrp: item.Mrp,
          };
        }),
        OutputList: outputList.map((item) => {
          return {
            _id: item._id,
            ProcessId: item.ProcessId,
            ItemId: item.ItemId,
            ItemName: dropdownData.product.find(
              (obj) => obj.value === item.ItemId
            )?.label,
            Quantity: item.Quantity,
            OriginalQuantity: item.OriginalQuantity,

            UnitId: item.UnitId,
            UnitName: dropdownData.units.find(
              (obj) => obj.value === item.UnitId
            )?.label,
            OriginalUnitId: item.OriginalUnitId,
            BatchId: item.BatchId,
            BatchNo: item.BatchNo,
            Warehouse: item.Warehouse,
            WarehouseName: dropdownData.warehouse.find(
              (dropdownItem) => dropdownItem.value === item.Warehouse
            )?.label,
            Rate: item.Rate,
            Mrp: item.Mrp,
            IsSalesOrderItem: !!item.IsSalesOrderItem,
            SalesOrderId: item.SalesOrderId || null,
            SalesOrderItemId: item.SalesOrderItemId || null,
          };
        }),
        UserId: userId,
        ManufacturingId: manufacturingId,
      };

      api.post(APIConstant.path.AddUpdateManufacturing, payload).then((res) => {
        if (res.Success == 1) {
          setLoading(false);
          cogoToast.success(res.Message);
          props.history.push({
            pathname: "/admin/manufacturing",
            state: {
              ManufacturingId: res.Data,
            },
          });
        } else {
          setLoading(false);
          cogoToast.error(res.Message);
        }
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const checkUnitConversion = async (data) => {
    try {
      const response = await api.post(
        APIConstant.path.CheckUnitConversion,
        data
      );
      return response;
    } catch (err) {
      console.error("Error:", err);
      return null;
    }
  };

  const addBatch = async () => {
    if (validateBatch()) {
      let params = {
        ...batchDetails,
        ExpiryDate: batchDetails.MfgDate
          ? moment(batchDetails.MfgDate)
            .add(parseInt(batchDetails.LifeSpan || 0), "days")
            .toDate()
          : "",
        UserId: userId,
      };
      api
        .post(APIConstant.path.AddBatch, params)
        .then((response) => {
          if (response.Success === 1) {
            cogoToast.success(response?.Message);
            GetProductMaster(userId);
            handleClose("addBatchDialog");
          } else {
            cogoToast.error(response?.Message || "");
          }
        })
        .catch((err) => { });
    }
  };

  const validateBatch = () => {
    let isValid = true;
    const updatedFormData = { ...batchDetails };

    const formFieldsToValidate = [
      { key: "MfgDate", label: "Date" },
      { key: "Mrp", label: "Mrp" },
      { key: "BatchNo", label: "Batch No" },
    ];

    for (const { key, label } of formFieldsToValidate) {
      const empty = CommonConfig.isEmpty(updatedFormData[key]);
      updatedFormData[`${key}Err`] = empty;
      updatedFormData[`${key}ErrText`] = empty ? `${label} is required` : "";
      if (empty) isValid = false;
    }

    setBatchDetails(updatedFormData);

    return isValid;
  };
  const validate = () => {
    let isValid = true;
    const updatedFormData = { ...formData };

    // ✅ 1. Validate Form Fields
    const formFieldsToValidate = [
      { key: "manufacturingDate", label: "Date" },
      { key: "process", label: "Process" },
      { key: "warehouse", label: "Warehouse" },
    ];

    for (const { key, label } of formFieldsToValidate) {
      const empty = CommonConfig.isEmpty(updatedFormData[key]);
      updatedFormData[`${key}Err`] = empty;
      updatedFormData[`${key}ErrText`] = empty ? `${label} is required` : "";
      if (empty) isValid = false;
    }

    setFormData(updatedFormData);

    if (!inputList.length || !outputList.length) {
      cogoToast.error("Please select items");
      isValid = false;
    }

    const validateItemFields = (items, fields, contextLabel = "Input") => {
      for (const item of items) {
        for (const { key, label } of fields) {
          if (CommonConfig.isEmpty(item[key])) {
            cogoToast.error(`${label} is required in ${contextLabel} items`);
            isValid = false;
            break;
          }
        }
      }
    };

    const inputFields = [
      { key: "ItemId", label: "Item" },
      { key: "UnitId", label: "Unit" },
      { key: "Quantity", label: "Quantity" },
      { key: "Rate", label: "Rate" },
    ];

    const outputFields = [
      ...inputFields,
      { key: "Warehouse", label: "Warehouse" },
      ...(formData.isBatch ? [{ key: "BatchId", label: "Batch" }] : []),
    ];

    validateItemFields(inputList, inputFields, "Input");
    validateItemFields(outputList, outputFields, "Output");

    return isValid;
  };

  const handleFormChange = (value, field, regex) => {
    if (!value || value?.length <= 0) {
      if (field === "process") {
        let tempRawData = [...inputList];
        let tempConvertedData = [...outputList];
        tempRawData = tempRawData.filter((data) => !data.ProcessId);
        tempConvertedData = tempConvertedData.filter((data) => !data.ProcessId);
        setInputList(tempRawData);
        setOutputList(tempConvertedData);
        setProcessMultiplyList([]);
        setTempProcessMultiplyList([]);
      }
      setFormData((prev) => ({
        ...prev,
        [field]: field === "process" ? [] : "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};

        if (field === "process") {
          let tempRawData = [...inputList];
          let tempConvertedData = [...outputList];

          value.forEach(async (id) => {
            let processData = dropdownData.process.find(
              (data) => data._id === id
            );
            let existingProcess = tempRawData.find(
              (data) => data.ProcessId === id
            );
            let tempProcessData = _.cloneDeep(processMultiplyList);
            if (!existingProcess) {
              tempProcessData.push({
                ProcessId: processData._id,
                ProcessName: processData.ProcessName,
                MultiplyBy: 1,
              });
            }
            setProcessMultiplyList(tempProcessData);
            setTempProcessMultiplyList(_.cloneDeep(tempProcessData));
            if (processData && processData.InputList?.length) {
              processData.InputList.forEach((input) => {
                if (!existingProcess) {
                  tempRawData.push({
                    ProcessId: id,
                    ItemName: input.ProductName,
                    ItemId: input.Product,
                    OriginalUnitId:
                      dropdownData.product.find(
                        (item) => item.value === input.Product
                      )?.UnitId || "",
                    UnitName: input.UnitName,
                    UnitId: input.Unit,
                    Quantity: input.Quantity,
                    OriginalQuantity: input.Quantity,
                    Rate: input.Rate,
                    Mrp: input.Amount,

                    MultiplyBy: 1,
                  });
                }
              });
            }
            if (processData && processData.OutputList?.length) {
              processData.OutputList.forEach((output) => {
                let existingProcess = tempConvertedData.find(
                  (data) => data.ProcessId === id
                );
                if (!existingProcess) {
                  tempConvertedData.push({
                    ProcessId: id,
                    ItemName: output.ProductName,
                    ItemId: output.Product,
                    OriginalUnitId:
                      dropdownData.product.find(
                        (item) => item.value === output.Product
                      )?.UnitId || "",
                    UnitName: output.UnitName,
                    UnitId: output.Unit,
                    Quantity: output.Quantity,
                    OriginalQuantity: output.Quantity,
                    Rate: "",
                    Mrp: "",
                    SubWarehouse: "",
                    BatchId: "",
                    BatchNo: "",
                  });
                }
              });
            }
          });
          formData.process.forEach((id) => {
            if (!value.includes(id)) {
              tempRawData = tempRawData.filter((data) => data.ProcessId !== id);
              tempConvertedData = tempConvertedData.filter(
                (data) => data.ProcessId !== id || data.IsSalesOrderItem
              );

              setProcessMultiplyList((prevState) =>
                prevState.filter((list) => list.ProcessId !== id)
              );
              setTempProcessMultiplyList((prevState) =>
                prevState.filter((list) => list.ProcessId !== id)
              );
            }
          });
          setInputList(tempRawData);
          setOutputList(tempConvertedData);
        }

        setFormData((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const onSelectSalesOrder = (salesOrderId) => {
    if (!salesOrderId) {
      // remove ONLY sales-order items
      setOutputList((prev) => prev.filter((o) => !o.IsSalesOrderItem));
      return;
    }

    // ✅ Find selected order from already-loaded state
    const order = dropdownData.salesOrder.find(
      (so) => so.value === salesOrderId
    );

    if (!order || !order.ItemList) return;

    const salesOutputs = order.ItemList.filter(
      (item) => Number(item.RemainingQty) > 0
    ).map((item) => ({
      ProcessId: null, // not from process
      ItemId: item.ItemId,
      ItemName: item.ItemName,
      OriginalUnitId: item.OriginalUnitId,
      UnitId: item.UnitId,
      UnitName: item.UnitName,
      Quantity: item.RemainingQty,
      OriginalQuantity: item.RemainingQty,
      Rate: item.RateExcludingGST,
      Mrp: item.MRP,
      Warehouse: "",
      BatchId: "",
      BatchNo: "",

      // ⭐ REQUIRED FLAGS
      IsSalesOrderItem: true,
      SalesOrderId: order._id || order.value,
      SalesOrderItemId: item._id,
    }));

    setOutputList((prev) => {
      // remove previous SO items, keep process/manual outputs
      const nonSales = prev.filter((o) => !o.IsSalesOrderItem);
      return [...nonSales, ...salesOutputs];
    });
  };

  const handleOpen = async (e, type) => {
    if (type === "addDataDialog") {
      setAddDataDialog(true);
    } else if (type === "MultiplyProcess") {
      setMultiplyProcessDialog(true);
    }
  };

  const handleClose = (type) => {
    if (type === "addDataDialog") {
      setAddDataDialog(false);
      setAddDataDetails({
        item: "",
        itemErr: false,
        itemErrText: "",
        unit: "",
        unitErr: false,
        unitErrText: "",
        quantity: "",
        quantityErr: false,
        quantityErrText: "",
        rate: "",
        mrp: "",
      });
      setReadOnly(false);
    } else if (type === "addBatchDialog") {
      setAddBatchDialog(false);
      setBatchDetails({});
    } else if (type === "multiplyProcessDialog") {
      setMultiplyProcessDialog(false);
      setTempProcessMultiplyList(_.cloneDeep(processMultiplyList));
    }
  };

  const handleMultiplyChange = (e, props) => {
    let tempProcessList = [...tempProcessMultiplyList];
    tempProcessList[props.rowIndex].MultiplyBy = e.target.value;
    setTempProcessMultiplyList(tempProcessList);
  };

  const handleMultiplyProcess = () => {
    setProcessMultiplyList(_.cloneDeep(tempProcessMultiplyList));
    let processMultiplyObj = {};
    tempProcessMultiplyList.forEach((process) => {
      processMultiplyObj[process.ProcessId] = process.MultiplyBy;
    });
    let tempRawData = [...inputList];
    tempRawData.forEach((data) => {
      if (data.ProcessId) {
        data.Quantity =
          processMultiplyObj[data.ProcessId] * data.OriginalQuantity;
        data.Mrp = processMultiplyObj[data.ProcessId] * data.Mrp;
      }
    });
    setInputList(tempRawData);
    let tempConvertedData = [...outputList];
    tempConvertedData.forEach((data) => {
      if (data.ProcessId) {
        data.Quantity =
          processMultiplyObj[data.ProcessId] * data.OriginalQuantity;
        data.Mrp = processMultiplyObj[data.ProcessId] * data.Mrp;
      }
    });
    setOutputList(tempConvertedData);
    setMultiplyProcessDialog(false);
  };

  const handleItemListChange = (value, field, regex) => {
    if (!value) {
      setAddDataDetails((prev) => ({
        ...prev,
        [field]: value,
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        setAddDataDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
        }));
      }
    }
  };
  const handleBatchDetailsChange = (value, field, regex) => {
    if (!value) {
      setBatchDetails((prev) => ({
        ...prev,
        [field]: value,
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      let extraObj = {};
      if (!regex || regex.test(value)) {
        setBatchDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const validateItem = () => {
    let isValid = true;

    let updatedFormData = { ...addDataDetails };

    const formFieldsToValidate = [
      { key: "item", label: "Item" },
      { key: "unit", label: "Unit" },
      { key: "rate", label: "Rate" },
      { key: "quantity", label: "Quantity" },
    ];

    formFieldsToValidate.forEach(({ key, label }) => {
      if (CommonConfig.isEmpty(updatedFormData[key])) {
        isValid = false;
        updatedFormData[`${key}Err`] = true;
        updatedFormData[`${key}ErrText`] = `${label} is required`;
      } else {
        updatedFormData[`${key}Err`] = false;
        updatedFormData[`${key}ErrText`] = "";
      }
    });

    setAddDataDetails(updatedFormData);

    return isValid;
  };

  const addDataList = async () => {
    if (validateItem()) {
      let quantityAvailable = addDataDetails.quantity;
      let response = await checkUnitConversion({
        OriginalUnitId:
          dropdownData.product.find(
            (item) => item.value === addDataDetails.item
          )?.UnitId || "",
        UnitId: addDataDetails.unit,
      });
      if (response.Data) {
        // quantityAvailable = quantityAvailable / response.Data;
      } else if (!response.Success) {
        // quantityAvailable = 0;
        cogoToast.error(response?.Message);
        return;
      }

      setInputList((prev) => [
        ...prev,
        {
          ItemId: addDataDetails.item,
          ItemName:
            dropdownData.product.find(
              (item) => item.value === addDataDetails.item
            )?.label || "",
          OriginalUnitId:
            dropdownData.product.find(
              (item) => item.value === addDataDetails.item
            )?.UnitId || "",
          UnitName:
            dropdownData.units.find(
              (item) => item.value === addDataDetails.unit
            )?.label || "",
          UnitId: addDataDetails.unit,
          Quantity: quantityAvailable,
          OriginalQuantity: quantityAvailable,
          Rate: addDataDetails.rate,
          Mrp:
            addDataDetails.rate && addDataDetails.quantity
              ? addDataDetails.rate * addDataDetails.quantity
              : 0,
        },
      ]);
      handleClose("addDataDialog");
    }
  };

  const removeItem = (index) => {
    setInputList((prev) => prev.filter((_, i) => i !== index));
  };

  const handleTableChange = (value, field, type, rowData, index, regex) => {
    const tempList = type === "Input" ? [...inputList] : [...outputList];

    let extraObj = {};

    if (!value) {
      if (field === "Rate") {
        extraObj.Mrp = 0;
      }
      tempList[index] = {
        ...tempList[index],
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
        ...extraObj,
      };
    } else {
      if (!regex || regex.test(value)) {
        if (field === "Rate") {
          extraObj.Mrp = parseFloat(rowData.Quantity * value).toFixed(2);
        }

        if (field === "BatchId") {
          extraObj.BatchNo = batchesList[rowData.ItemId].find(
            (batch) => batch.value === value
          )?.label;
        }

        tempList[index] = {
          ...tempList[index],
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        };
      }
    }
    if (type === "Input") {
      setInputList(tempList);
    } else {
      setOutputList(tempList);
    }
  };

  const actionBodyTemplate = (rowData, props, field, type, regex) => {
    if (readOnly) {
      return rowData[field];
    }
    return (
      <InputText
        value={rowData[field]}
        onChange={(e) =>
          handleTableChange(
            e.target.value,
            field,
            type,
            rowData,
            props.rowIndex,
            regex
          )
        }
        maxLength={20}
        placeholder="Enter value"
      />
    );
  };

  const actionBodyMultiplyBy = (rowData, props) => {
    return (
      <>
        <InputText
          autoFocus
          margin="dense"
          name="MultiplyBy"
          value={rowData.MultiplyBy}
          onChange={(e) => handleMultiplyChange(e, props)}
          inputProps={{ maxLength: 10 }}
          fullWidth
        />
      </>
    );
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="ship-heading-area p-d-flex p-ai-center"
          onClick={() => {
            props.history.push("/admin/manufacturing");
          }}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>Manufacturing</h2>
        </div>
      </div>
      <hr />
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid">
            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Manufacturing Date</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.manufacturingDate
                        ? moment(formData.manufacturingDate).format(
                          "DD/MM/YYYY"
                        )
                        : ""}
                    </p>
                  ) : (
                    <>
                      <div>
                        <Datetime
                          value={moment(formData.manufacturingDate)}
                          onChange={(date) => {
                            handleFormChange(date, "manufacturingDate");
                          }}
                          closeOnSelect={true}
                          renderInput={(params) => (
                            <TextField {...params} out fullWidth autoFocus />
                          )}
                          dateFormat="DD/MM/YYYY"
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.manufacturingDateErr
                          ? formData.manufacturingDateErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <p className="text p-mb-1">Process</p>
                <div className="custom-inputs e-order-mng order p-d-flex p-ai-center">
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.processDetails
                        ?.map((process) => process.name)
                        ?.join()}
                    </p>
                  ) : (
                    <>
                      <div className="p-w-100">
                        <MultiSelect
                          value={formData.process}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "process")
                          }
                          options={dropdownData.process}
                          optionLabel="label"
                          placeholder="Select Process"
                          className="p-w-100"
                          disabled={readOnly}
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.processErr ? formData.processErrText : null}{" "}
                      </span>
                      {!readOnly && (
                        <div
                          className="filter-btn cursor-pointer"
                          onClick={(e) => handleOpen(e, "MultiplyProcess")}
                        >
                          <i className="icon-add"></i>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">To Warehouse</p>
                  {readOnly ? (
                    <p className="sub-text">
                      {formData.warehouseDetails
                        ?.map((warehouse) => warehouse.name)
                        ?.join()}
                    </p>
                  ) : (
                    <>
                      <div>
                        <MultiSelect
                          value={formData.warehouse}
                          onChange={(e) =>
                            handleFormChange(e.target.value, "warehouse")
                          }
                          options={dropdownData.warehouse}
                          optionLabel="label"
                          placeholder="Select Warehouse"
                          className="p-w-100"
                          disabled={readOnly}
                        />
                      </div>
                      <span className="error-msg" style={{ color: "red" }}>
                        {formData.warehouseErr
                          ? formData.warehouseErrText
                          : null}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12 p-md-3">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Sales Order</p>
                  {readOnly ? (
                    <p className="sub-text">{formData.salesOrderNo || "-"}</p>
                  ) : (
                    <>
                      <div>
                        <Dropdown
                          value={formData.salesOrder}
                          onChange={(e) => {
                            handleFormChange(e.target.value, "salesOrder");
                            onSelectSalesOrder(e.value);
                          }}
                          options={dropdownData.salesOrder}
                          placeholder="Select Sales Order"
                          className="p-w-100"
                          disabled={readOnly}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="p-sm-12 p-md-3">
              <div className="flex align-items-center p-mt-4">
                <Checkbox
                  inputId="apply"
                  name="isBatch"
                  disabled={readOnly}
                  onChange={(e) => handleFormChange(e?.checked, "isBatch")}
                  checked={formData.isBatch}
                />
                <label htmlFor="apply" className="p-ml-2">
                  Batch
                </label>
              </div>
            </div>
          </div>

          {userPageAccess.includes("Show Input Items") && (
            <>
              <div>
                <h3>Input</h3>
              </div>
              <div className="item-section">
                <DataTable
                  className="main-table table-td"
                  value={inputList}
                  key={inputList}
                  editMode="row"
                  dataKey="id"
                  responsiveLayout="scroll"
                  emptyMessage="No records found"
                  columnResizeMode="fit"
                  scrollable={true}
                >
                  <Column
                    field="Index"
                    header="Sr.No"
                    body={actionBodyTemplateSrNo}
                    style={{ width: "100px" }}
                  ></Column>
                  <Column
                    field="ItemName"
                    header="Item"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="UnitName"
                    header="Unit"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Quantity"
                    header="Quantity"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Rate"
                    header="Rate"
                    body={(rowData, props) =>
                      actionBodyTemplate(
                        rowData,
                        props,
                        "Rate",
                        "Input",
                        /^\d+(\.\d{0,2})?$/i
                      )
                    }
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Mrp"
                    header="Mrp"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    header="Action"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) => (
                      <div>
                        {!rowData.ProcessId && !readOnly && (
                          <i
                            class="icon-delete"
                            onClick={() => {
                              removeItem(props.rowIndex);
                            }}
                          ></i>
                        )}
                      </div>
                    )}
                  ></Column>
                </DataTable>

                {!readOnly && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      handleOpen(e, "addDataDialog");
                    }}
                  >
                    Add Item
                  </Button>
                )}
              </div>
            </>
          )}

          <div>
            <h3>Output</h3>
          </div>
          <div className="item-section">
            <DataTable
              className="main-table table-td"
              value={outputList}
              key={outputList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              emptyMessage="No records found"
              columnResizeMode="fit"
              scrollable={true}
            >
              <Column
                field="Index"
                header="Sr.No"
                body={actionBodyTemplateSrNo}
                style={{ width: "20% !important" }}
              ></Column>
              <Column
                field="ItemName"
                header="Item"
                style={{ width: "20% !important" }}
              ></Column>
              <Column
                field="UnitName"
                header="Unit"
                style={{ width: "20% !important" }}
              ></Column>
              <Column
                field="Quantity"
                header="Quantity"
                style={{ width: "20% !important" }}
              ></Column>
              {!!formData.isBatch && (
                <Column
                  field="BatchId"
                  header="Batch"
                  body={(rowData, props) => {
                    // actionBodyTemplate(rowData, props, "Batch", "Ouput")
                    return readOnly ? (
                      rowData.BatchNo
                    ) : (
                      <div className="p-d-flex p-ai-center">
                        <Dropdown
                          filter
                          options={batchesList[rowData.ItemId]}
                          value={rowData.BatchId}
                          onChange={(e) =>
                            handleTableChange(
                              e.value,
                              "BatchId",
                              "Output",
                              rowData,
                              props.rowIndex
                            )
                          }
                          placeholder="Batch"
                          className="p-w-100"
                        />
                        <div /*className="p-d-flex p-pt-1 p-mt-2"*/>
                          <button
                            className="filter-btn cursor-pointer"
                            onClick={() => {
                              setAddBatchDialog(true);
                              setBatchDetails({
                                ItemId: rowData.ItemId,
                                LifeSpan: dropdownData.product.find(
                                  (item) => item.value === rowData.ItemId
                                )?.LifeSpan,
                              });
                            }}
                          >
                            <i className="icon-add"></i>
                          </button>
                        </div>
                      </div>
                    );
                  }}
                  style={{ width: "20% !important" }}
                ></Column>
              )}
              <Column
                field="Rate"
                header="Rate"
                body={(rowData, props) =>
                  actionBodyTemplate(
                    rowData,
                    props,
                    "Rate",
                    "Output",
                    /^\d+(\.\d{0,2})?$/i
                  )
                }
                style={{ width: "20% !important" }}
              ></Column>
              <Column
                field="Mrp"
                header="Mrp"
                style={{ width: "20% !important" }}
              ></Column>
              <Column
                field="Warehouse"
                header="Warehouse"
                style={{ width: "20% !important" }}
                body={(rowData, props) => {
                  return readOnly ? (
                    rowData.WarehouseName
                  ) : (
                    <Dropdown
                      filter
                      options={dropdownData.warehouse}
                      value={rowData.Warehouse}
                      onChange={(e) =>
                        handleTableChange(
                          e.value,
                          "Warehouse",
                          "Output",
                          rowData,
                          props.rowIndex
                        )
                      }
                      placeholder="Warehouse"
                      className="p-w-100"
                    />
                  );
                }}
              ></Column>
            </DataTable>
          </div>
        </div>
      </div>
      <div>
        <div className="p-d-flex p-ai-center p-jc-end">
          <button
            className="btn-dialog-cancel"
            onClick={() => {
              props.history.push("/admin/manufacturing");
            }}
          >
            Cancel
          </button>
          {readOnly ? null : (
            <Button
              className="e-add-btn color-white p-ml-1"
              onClick={AddUpdateManufacturing}
              disabled={loading}
            >
              Submit
            </Button>
          )}
        </div>
      </div>

      <Dialog
        open={addDataDialog}
        onClose={() => handleClose("addDataDialog")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Input Data</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("addDataDialog")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Item</p>
                  <div>
                    <Dropdown
                      filter
                      options={dropdownData.product}
                      value={addDataDetails.item}
                      onChange={(e) => handleItemListChange(e.value, "item")}
                      placeholder="Item"
                      className="p-w-100"
                    />
                  </div>
                  <span className="error-msg" style={{ color: "red" }}>
                    {addDataDetails.itemErr ? addDataDetails.itemErrText : null}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Unit</p>
                  <div>
                    <Dropdown
                      filter
                      options={dropdownData.units}
                      value={addDataDetails.unit}
                      onChange={(e) => handleItemListChange(e.value, "unit")}
                      placeholder="Unit"
                      className="p-w-100"
                    />
                  </div>
                  <span className="error-msg" style={{ color: "red" }}>
                    {addDataDetails.unitErr ? addDataDetails.unitErrText : null}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Quantity</p>
                  <div>
                    <InputText
                      autoFocus
                      className="p-w-100"
                      margin="dense"
                      name="quantity"
                      value={addDataDetails.quantity}
                      onChange={(e) =>
                        handleItemListChange(
                          e.target.value,
                          "quantity",
                          /^\d+(\.\d{0,2})?$/i
                        )
                      }
                      inputProps={{ maxLength: 10 }}
                      fullWidth
                    />
                  </div>
                  <span className="error-msg" style={{ color: "red" }}>
                    {addDataDetails.quantityErr
                      ? addDataDetails.quantityErrText
                      : null}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Rate</p>
                  <div>
                    <InputText
                      autoFocus
                      className="p-w-100"
                      margin="dense"
                      name="rate"
                      value={addDataDetails.rate}
                      onChange={(e) =>
                        handleItemListChange(
                          e.target.value,
                          "rate",
                          /^\d+(\.\d{0,2})?$/i
                        )
                      }
                      inputProps={{ maxLength: 10 }}
                      fullWidth
                    />
                  </div>
                  <span className="error-msg" style={{ color: "red" }}>
                    {addDataDetails.rateErr ? addDataDetails.rateErrText : null}
                  </span>
                </div>
              </div>
            </div>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("addDataDialog")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => addDataList(e)}
            type="submit"
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addBatchDialog}
        onClose={() => handleClose("addBatchDialog")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Batch</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("addBatchDialog")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Batch No</p>
                  <div>
                    <InputText
                      autoFocus
                      className="p-w-100"
                      margin="dense"
                      name="BatchNo"
                      value={batchDetails.BatchNo}
                      onChange={(e) =>
                        handleBatchDetailsChange(e.target.value, "BatchNo")
                      }
                      inputProps={{ maxLength: 20 }}
                      fullWidth
                    />
                  </div>
                  <span className="error-msg" style={{ color: "red" }}>
                    {batchDetails.BatchNoErr
                      ? batchDetails.BatchNoErrText
                      : null}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">Mrp</p>
                  <div>
                    <InputText
                      autoFocus
                      className="p-w-100"
                      margin="dense"
                      name="Mrp"
                      value={batchDetails.Mrp}
                      onChange={(e) =>
                        handleBatchDetailsChange(
                          e.target.value,
                          "Mrp",
                          /^\d+(\.\d{0,2})?$/i
                        )
                      }
                      inputProps={{ maxLength: 20 }}
                      fullWidth
                    />
                  </div>
                  <span className="error-msg" style={{ color: "red" }}>
                    {batchDetails.MrpErr ? batchDetails.MrpErrText : null}
                  </span>
                </div>
              </div>
            </div>
            <div className="p-sm-12 p-md-12">
              <div className="p-w-100 ">
                <div className="custom-inputs e-order-mng order">
                  <p className="text p-mb-1">MFG Date & Time</p>

                  <>
                    <div>
                      <Datetime
                        value={
                          batchDetails.MfgDate
                            ? moment(batchDetails.MfgDate)
                            : ""
                        }
                        onChange={(date) => {
                          handleBatchDetailsChange(date, "MfgDate");
                        }}
                        closeOnSelect={true}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                        dateFormat="DD/MM/YYYY"
                      />
                    </div>
                    <span className="error-msg" style={{ color: "red" }}>
                      {batchDetails.MfgDateErr
                        ? batchDetails.MfgDateErrText
                        : null}
                    </span>
                  </>
                </div>
              </div>
            </div>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("addBatchDialog")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => addBatch(e)}
            type="submit"
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={multiplyProcessDialog}
        onClose={() => handleClose("multiplyProcessDialog")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Process Multiplication</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("multiplyProcessDialog")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <DataTable
              className="main-table table-td"
              value={tempProcessMultiplyList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              emptyMessage="No records found"
              columnResizeMode="fit"
              scrollable={true}
            >
              <Column
                field="Index"
                header="Sr.No"
                body={actionBodyTemplateSrNo}
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="ProcessName"
                header="Process Name"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="MultiplyBy"
                header="Multiply"
                style={{ width: "20%" }}
                body={actionBodyMultiplyBy}
              ></Column>
            </DataTable>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("multiplyProcessDialog")}
          >
            Cancel
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleMultiplyProcess(e)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddManufacturing;
